import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons';
import { type ClientInfo } from '../../types';

type Props = {
  client?: ClientInfo;
  className?: string;
};

/**
 * HostedClientLogo — Renders the client's logo image, an initials avatar,
 * or a generic shield icon as a last resort.
 */
export default function HostedClientLogo({
  client,
  className = 'h-9 object-contain',
}: Props) {
  if (client?.image) {
    return <img src={client.image} alt={client.name} className={className} />;
  }

  if (client?.name) {
    const initials = client.name
      .split(/\s+/)
      .slice(0, 2)
      .map((w) => w[0])
      .join('')
      .toUpperCase();

    return (
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted text-sm font-semibold text-muted-foreground">
        {initials}
      </div>
    );
  }

  return (
    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-muted">
      <FontAwesomeIcon
        icon={faShieldCheck}
        className="size-5 text-muted-foreground"
      />
    </div>
  );
}
